import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
//import moment from "moment";
import React, { useEffect, useState } from "react";
import { List } from "react-virtualized";
import BaseGreeks from "src/apis/mock/data/basegreeks";
import { MAX_SCREEN_WIDTH } from "src/utils/constant";
import { useAppDispatch } from "../../../hooks/redux";
import styles from "./fullscreen-oc-view.module.scss";
import TableHeader from "./table-header";
import TableRow from "./table-row";
import { getPriceOcRowsHeight } from "src/utils/methods";
const GreeksTable = React.lazy(() => import("./greeksTable"));
const FullScreenOCView = (props) => {
    const dispatch = useAppDispatch();
    const { isOcIframe, id, optionsChain, symbol, expiry, limit, isMultiple, isHoverEnabled, position, lotSize, checkboxEnabled, selectedOptionType, isHide, spotScripDetails, expandedNewTab, } = props;
    const getStrikeChainList = () => {
        let localChain = Object.keys(optionsChain || {});
        localChain = localChain.sort((singleElement1, singleElement2) => {
            return Number(singleElement1) - Number(singleElement2);
        });
        if (limit) {
            const scrollIndex = localChain.findIndex((singleElement) => {
                return singleElement == props.activeStrike + "";
            });
            const floredLimit = Math.floor(limit / 2);
            //put this ternanry operator for even odd condition
            //in odd condition one data is ommited while dividing
            let start = scrollIndex - floredLimit;
            let end = limit % 2 === 0
                ? scrollIndex + floredLimit
                : scrollIndex + floredLimit + 1;
            if (start < 0) {
                start = 0;
            }
            if (end > localChain.length) {
                end = localChain.length;
            }
            localChain = localChain.slice(start, end);
        }
        else {
            // chain = Object.keys(optionsChain || {});
        }
        return localChain;
    };
    const [chain, setChain] = useState(getStrikeChainList());
    const [greeksData, setGreeksData] = useState();
    const [scrollToIndex, setScrollToIndex] = useState(0);
    // const chain = getStrikeChainList();
    const createArray = (List) => {
        if (!optionsChain) {
            // console.log("NO OC");
            return;
        }
        const geeksData = [];
        let geeksDataObj = {};
        const renderList = List ? List : chain;
        renderList.forEach((singleStrike) => {
            if (optionsChain[singleStrike]) {
                if (singleStrike.includes(".")) {
                    geeksDataObj = Object.assign(Object.assign({}, geeksDataObj), { [singleStrike]: optionsChain[singleStrike] });
                }
                else {
                    geeksDataObj = Object.assign(Object.assign({}, geeksDataObj), { [singleStrike + ".00"]: optionsChain[singleStrike] });
                }
            }
        });
        //console.log(geeksDataObj, "OCCCC");
        setGreeksData(geeksDataObj);
    };
    // useEffect(() => {
    //   setScrollToIndex(0);
    // }, []);
    useEffect(() => {
        if (selectedOptionType == "Greeks") {
            createArray();
        }
    }, [selectedOptionType, checkboxEnabled]);
    useEffect(() => {
        const chain = getStrikeChainList();
        setChain(chain);
        //console.log(props.activeStrike, "props.activeStrike");
        const scrollIndex = chain.findIndex((singleElement) => {
            return singleElement == props.activeStrike + "";
        });
        if (scrollIndex > 0) {
            const scrollTo = scrollIndex - 4;
            // console.log(inputRef.current.reScroll, "check boolean");
            // console.log(inputRef.current.scrollTo, scrollTo, "INDEX CHECK");
            // if (inputRef.current.scrollTo != scrollTo && !inputRef.current.reScroll) {
            setScrollToIndex(scrollTo);
            //console.log(scrollToIndex, "$$$$");
            // }
        }
        else {
            setScrollToIndex(0);
        }
        if (selectedOptionType == "Greeks") {
            createArray(chain);
        }
    }, [limit]);
    const renderRow = (data) => {
        const { index, key, style } = data;
        const strike = Number(chain[index]);
        if (strike == props.activeStrike) {
            // console.log(inputRef.current.reScroll, "check boolean");
            // console.log(inputRef.current.scrollTo, index - 4, "INDEX CHECK");
            // if (!(scrollToIndex == index - 4)) {
            //   console.log(index, "index");
            // setScrollToIndex(index - 4);
            // }
            //   console.log(scrollToIndex, "----");
            // }
        }
        //  [{ceLTP,peLtp}]
        if (optionsChain[strike] && Object.keys(optionsChain).length > 0) {
            const { PE: { OI: putOI = 0, OI_CHANGE: putOIPerc = "0", LTP: putLTP = 0, PREVIOUS_CLOSE: prevPutClose = 0, PREV_OI: prevOIPut = 0, MAX_OI: putMaxOI = 0, EXCH: putExch = "", EXCH_TYPE: putExchType = "", NAME: putName = "", SCRIPT_CODE: putScripCode = 0, BID_QTY: putBidQty = 0, BID_RATE: putBidRate = "-", OFF_RATE: putOffRate = "-", TOTAL_QTY: putTotalQty = "-", isChecked: putCheckBox = false, GREEKS_DATA: putGreeksData = BaseGreeks(), }, CE: { OI: callOI = 0, OI_CHANGE: callOIPerc = "0", LTP: callLTP = 0, PREVIOUS_CLOSE: prevCallClose = 0, PREV_OI: prevOICall = 0, MAX_OI: callMaxOI = 0, EXCH: callExch = "", EXCH_TYPE: callExchType = "", NAME: callName = "", SCRIPT_CODE: callScripCode = 0, BID_QTY: callBidQty = 0, BID_RATE: callBidRate = "-", OFF_RATE: callOffRate = "-", TOTAL_QTY: callTotalQty = "-", isChecked: callCheckBox = false, GREEKS_DATA: callGreeksData = BaseGreeks(), }, } = (optionsChain || {})[strike] || {};
            const callOIDiff = callOI - prevOICall;
            const putOIDiff = putOI - prevOIPut;
            let callIndicatorWidth = "0";
            let putIndicatorWidth = "0";
            if (callMaxOI > 0) {
                callIndicatorWidth = ((callOI * 100) / callMaxOI).toFixed(2);
            }
            if (putMaxOI > 0) {
                putIndicatorWidth = ((putOI * 100) / putMaxOI).toFixed(2);
            }
            return (_jsx("div", Object.assign({ style: style }, { children: _jsx(TableRow, { isOcIframe: isOcIframe, symbol: props.symbol, expiry: props.expiry, i: index, strike: strike, isMultiple: isMultiple, activeStrike: props.activeStrike, callLTP: callLTP, putLTP: putLTP, callOI: callOI, putOI: putOI, callOIPerc: callOIPerc, putOIPerc: putOIPerc, callBidQty: callBidQty, putBidQty: putBidQty, callBidRate: callBidRate, putBidRate: putBidRate, callOIDiff: callOIDiff, putOIDiff: putOIDiff, callIndicatorWidth: callIndicatorWidth, putIndicatorWidth: putIndicatorWidth, callExch: callExch, callExchType: callExchType, callScripCode: callScripCode, putExch: putExch, putExchType: putExchType, putScripCode: putScripCode, callName: callName, putName: putName, callOffRate: callOffRate, putOffRate: putOffRate, prevCallClose: prevCallClose, prevPutClose: prevPutClose, isHoverEnabled: isHoverEnabled, type: "", putCheckBox: putCheckBox, callCheckBox: callCheckBox, optionsChain: optionsChain, position: position, totalCount: undefined, lotSize: lotSize, checkboxEnabled: checkboxEnabled, selectedOptionType: selectedOptionType, 
                    // openFeedGreeks={openFeedGreeks}
                    callGreeksData: callGreeksData, putGreeksData: putGreeksData, prevOIPut: prevOIPut, prevOICall: prevOICall, putTotalQty: putTotalQty, callTotalQty: callTotalQty, spotScripDetails: spotScripDetails }, chain[index]) }), key));
        }
        else {
            return _jsx(_Fragment, {});
        }
    };
    return (_jsxs(_Fragment, { children: [selectedOptionType != "Greeks" && (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: `${styles.optionChain} largeViewHandleOC` }, { children: _jsxs(_Fragment, { children: [_jsx(TableHeader, { isMultiple: isMultiple, checkboxEnabled: checkboxEnabled, selectedOptionType: selectedOptionType }), _jsx("div", Object.assign({ className: `${selectedOptionType}` }, { children: _jsx(List, { style: {
                                        width: selectedOptionType != "Greeks"
                                            ? "100%"
                                            : isMultiple
                                                ? "44vw"
                                                : "92vw",
                                        overflow: "auto",
                                    }, width: selectedOptionType != "Greeks" ? 4000 : 1257, height: isOcIframe
                                        ? getPriceOcRowsHeight()
                                        : !expandedNewTab
                                            ? window.innerHeight - 240
                                            : window.innerHeight - 180, rowHeight: selectedOptionType == "Straddle" &&
                                        window.innerWidth > MAX_SCREEN_WIDTH
                                        ? 43
                                        : 40, rowRenderer: renderRow, rowCount: chain.length, scrollToAlignment: "start", scrollToIndex: scrollToIndex }) }))] }) })) })), selectedOptionType == "Greeks" && (_jsx(_Fragment, { children: _jsxs(React.Suspense, Object.assign({ fallback: _jsx(_Fragment, {}) }, { children: [_jsx(GreeksTable, { optionsChain: optionsChain, chain: chain, activeStrike: props.activeStrike, spotScripDetails: spotScripDetails, lotSize: lotSize, greeksData: greeksData, position: position, isMultiple: isMultiple, symbol: props.symbol, expiry: props.expiry, limit: limit, checkboxEnabled: checkboxEnabled, expandedNewTab: expandedNewTab }), " "] })) }))] }));
};
export default FullScreenOCView;
